import { useCallback } from 'react';
import config from '../config';
import { TagUsage } from '../types';
import prepareHeaders from '../utilities/prepare-headers';
import { useAuth } from './auth';

const TAG_SUGGESTIONS_LIMIT = 8;

const useTags = () => {
  const { token } = useAuth();

  // Suggestions are a convenience, so errors are ignored rather than shown
  const fetchTags = useCallback(
    async (prefix: string, signal?: AbortSignal): Promise<TagUsage[]> => {
      const params = new URLSearchParams({
        prefix,
        limit: TAG_SUGGESTIONS_LIMIT.toString(),
      });

      try {
        const response = await fetch(
          `${config.api.url}/dashboard/tags?${params}`,
          {
            method: 'GET',
            headers: prepareHeaders(token),
            signal,
          }
        );

        if (!response.ok) {
          return [];
        }

        return ((await response.json()) as { data: TagUsage[] }).data;
      } catch {
        return [];
      }
    },
    [token]
  );

  return {
    fetchTags,
  };
};

export default useTags;
